import { isEmpty } from 'lodash';
import queryString from 'qs';

import convertStatusProgress from 'Domain/reschedule/helper/convertStatusProgress';

export const getRequestApprovalRequest = (queryParams) => {
  const queries = { limit: queryParams?.limit, page: queryParams?.page };

  if (queryParams?.tableView && isEmpty(queryParams?.statusProgress))
    queries.statusProgress = `[${convertStatusProgress(queryParams?.tableView)?.map((item) => item?.label)}]`;

  if (queryParams?.sort) queries.sort = `${queryParams?.sort?.field}.${queryParams?.sort?.order}`;
  if (queryParams?.search) queries.search = queryParams?.search;

  if (queryParams?.brand?.length) queries['schedule.hosts.brands.name'] = `[${queryParams?.brand?.map((item) => item?.value)}]`;
  if (queryParams?.typeId?.length) queries.typeId = `[${queryParams?.typeId?.map((item) => item?.value)}]`;
  if (queryParams?.statusProgress?.length) queries.statusProgress = `[${queryParams?.statusProgress?.map((item) => item?.label)}]`;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getRequestApprovalRequest;
